import { AwardsModulePartnerLogos } from '../../../types/components'
import Image from 'next/image'
const ModulePartnerPage = ({
  moduleProps
}: {
  moduleProps: AwardsModulePartnerLogos['attributes']
}) => {
  return (
    <div className='px-0 md:px-[18px]'>
      <div className='section mb-[28px] md-md[60px] lg:mb-[50px]'>
        <div className='flex flex-col items-center justify-center w-full'>
          <div className='mb-[5px] md:mb-[8px] lg:mb-[16px] font-abcd uppercase 
          font-extrabold text-[23px] md:text-[30px] lg:text-[28px] md:font-[800] md:leading-[100%]
           md:tracking-[-0.05em] md:align-bottom md:uppercase lg:text-[28.24px] leading-[100%] 
           tracking-[-5%] align-bottom'>{moduleProps.mainHeading}</div>
          <div className='w-full h-[0.25px] md-h-[0.5px] lg-h-[1px] bg-black mb-[15px] md:mb-[8px] lg:mb-[16px]' />
        </div>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-[18px] md:gap-4 mb-[60px]'>
          {/**
           * Make an iteration of 6 times to render the image 6 times
           */}
          {Array.from({ length: 6 }, (_, index) => index).map((index) => (
            // @ts-ignore
            moduleProps[`image${index + 1}`].data?.attributes.url &&
            <Image
              key={index}
              // @ts-ignore
              alt={moduleProps[`title${index + 1}`]}
              width={900}
              height={600}
              objectFit='contain'
              className='mb-[10px]'
              src={
                // @ts-ignore
                moduleProps[`image${index + 1}`].data.attributes.url
              }
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ModulePartnerPage
